export default function () {
  this.idAssociazione = null;
  this.Sezione = null;
  this.AnnoSportivo = null;
  this.TipoEvento = null;
  this.MeseSelezionato = null;
  this.AnnoSelezionato = null;
  this.TitoloEvento = null;
  this.DataApertura = null;
  this.DataChiusura = null;
  this.DataEvento = null;
  this.StatoEvento = null;
  this.isAttivo = false;
  this.isNotIscritto = true;
  this.isAnnuale = true;
  this.isAperti = true;
  this.isGara = true;
  this.isIndoorOutdoor = null;
}
